import { Stack, Link, Typography } from '@mui/material'
import getEnv from '@src/utils/envUtils'
import React from 'react'
import { useTranslation } from 'react-i18next'

const Footer = (): JSX.Element => {
  const { t } = useTranslation('repairshop')
  const { brand, officePhone, officePhoneUrl } = getEnv()

  return (
    <Stack
      justifyContent={'center'}
      alignItems={'center'}
      gap={1}
      sx={{
        backgroundColor: 'primary.main',
        textAlign: 'center',
        color: 'primary.contrastText',
        py: 2,
        px: 3,
        '& p': {
          fontSize: '14px',
        },
      }}
      role={'contentinfo'}
    >
      <Typography variant="h4" component="h2" sx={{ fontWeight: '900' }}>
        {t('footer.claims-service-time')}
      </Typography>
      <Typography variant="body1" component="p">
        {brand === 'POP'
          ? t('footer.claims-service-help-pop')
          : t('footer.claims-service-help-sp')}
      </Typography>
      <Link href={`tel:${officePhoneUrl}`}>
        <Typography
          variant="body1"
          component="p"
          sx={{ color: 'white', display: 'inline-block' }}
        >
          {t('footer.claims-service-phone')}&nbsp;
          {officePhone}
        </Typography>
      </Link>
      {brand === 'POP' && (
        <Typography variant="body1" component="p">
          {t('footer.calling-price')}
        </Typography>
      )}
    </Stack>
  )
}

export default Footer
